/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_No_Notes_AvailableInputs */

const en_read_along_no_notes_available = /** @type {(inputs: Read_Along_No_Notes_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No notes available`)
};

const es_read_along_no_notes_available = /** @type {(inputs: Read_Along_No_Notes_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay notas disponibles`)
};

/**
* | output |
* | --- |
* | "No notes available" |
*
* @param {Read_Along_No_Notes_AvailableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_no_notes_available = /** @type {((inputs?: Read_Along_No_Notes_AvailableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_No_Notes_AvailableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_no_notes_available(inputs)
	return en_read_along_no_notes_available(inputs)
});